import { Link } from 'react-router-dom';
import { latestMovies } from '@/mocks/movies';

const latestThumbs: Record<number, string> = {
  201: 'https://readdy.ai/api/search-image?query=Courtroom%20drama%20cinematic%20still%20with%20warm%20atmosphere%2C%20legal%20scene%2C%20professional%20movie%20cinematography%2C%20soft%20lighting&width=320&height=180&seq=latest-movie-thumb-201&orientation=landscape',
  202: 'https://readdy.ai/api/search-image?query=Racing%20car%20cinematic%20still%20with%20warm%20atmosphere%2C%20dynamic%20action%20scene%2C%20professional%20movie%20cinematography%2C%20motion%20blur&width=320&height=180&seq=latest-movie-thumb-202&orientation=landscape',
  203: 'https://readdy.ai/api/search-image?query=Animated%20family%20cinematic%20still%20with%20warm%20atmosphere%2C%20adventure%20scene%2C%20professional%20animation%20cinematography%2C%20colorful%20lighting&width=320&height=180&seq=latest-movie-thumb-203&orientation=landscape',
  204: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20cinematic%20still%20with%20dark%20atmosphere%2C%20police%20scene%2C%20professional%20movie%20cinematography%2C%20moody%20lighting&width=320&height=180&seq=latest-movie-thumb-204&orientation=landscape',
  205: 'https://readdy.ai/api/search-image?query=Office%20comedy%20cinematic%20still%20with%20warm%20atmosphere%2C%20corporate%20party%20scene%2C%20professional%20movie%20cinematography%2C%20bright%20lighting&width=320&height=180&seq=latest-movie-thumb-205&orientation=landscape',
  206: 'https://readdy.ai/api/search-image?query=Dark%20ocean%20cinematic%20still%20with%20moody%20atmosphere%2C%20thriller%20scene%2C%20professional%20movie%20cinematography%2C%20storm%20lighting&width=320&height=180&seq=latest-movie-thumb-206&orientation=landscape',
  207: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20cinematic%20still%20with%20warm%20atmosphere%2C%20adventure%20scene%2C%20professional%20anime%20cinematography%2C%20golden%20sunset%20lighting&width=320&height=180&seq=latest-movie-thumb-207&orientation=landscape',
  208: 'https://readdy.ai/api/search-image?query=War%20battle%20cinematic%20still%20with%20dramatic%20atmosphere%2C%20epic%20action%20scene%2C%20professional%20movie%20cinematography%2C%20smoke%20and%20fire&width=320&height=180&seq=latest-movie-thumb-208&orientation=landscape',
};

export default function LatestList() {
  return (
    <section className="w-full px-4 md:px-8 py-6 md:py-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-5 md:mb-6">
          <div className="flex items-center gap-2">
            <h3 className="text-lg md:text-xl font-heading text-foreground-100">
              最新上线
            </h3>
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-500"></span>
            </span>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            更多新片
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-base"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {latestMovies.map((movie, idx) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex items-start gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200/60 transition-colors border border-background-300/20 hover:border-background-300/40"
            >
              <div className="relative flex-shrink-0 w-16 h-9 rounded overflow-hidden bg-background-200">
                <img
                  src={latestThumbs[movie.id] || movie.thumbUrl}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1">
                  <span className="text-xs font-medium text-foreground-700 w-4">{idx + 1}</span>
                  <h4 className="text-sm font-medium text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-1">
                    {movie.title}
                  </h4>
                  {idx < 3 && (
                    <span className="flex-shrink-0 px-1.5 py-0.5 bg-accent-500/20 text-accent-400 rounded text-[10px] font-medium">
                      NEW
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-0.5">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-amber-400"></i>
                    </span>
                    {movie.rating}
                  </span>
                  <span>{movie.updateInfo}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}